import { UsageLog } from 'shared/model/usageLog.model';

type Props = {
  item: UsageLog;
};

const UsageLogItem = ({ item }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '1rem',
      }}
    >
      <div>{item.date}</div>
      <div>{item.type}</div>
      <div>{item.content ? JSON.stringify(item.content) : 'No content'}</div>
      <div>{item.userId}</div>
    </div>
  );
};

export default UsageLogItem;
